// Shared spatial layout for the WTC site (meters, Y-up, site centered near origin).
export const SCALE = 1;

export const POS = {
  northPool: [-46, 0, -46], // North Tower (1 WTC 2001) footprint
  southPool: [24, 0, 40], // South Tower (2 WTC 2001) footprint
  oneWTC: [-124, 0, -112], // 2026 One World Trade Center
  sphere: [-8, 0, -2], // 2001 plaza Sphere fountain
  oculus: [82, 0, 8], // 2026 Oculus transit hub
};

export const TOWER = { footprint: 63, height: 417, roofBlock: 30 };
export const POOL = { size: 76, depth: 6, wall: 3 };

// Preset landmark cameras: {position, target}
export const LANDMARKS = [
  {
    key: "North Pool",
    era: "2026",
    position: [-46, 22, 30],
    target: [-46, -2, -46],
  },
  {
    key: "1 WTC Spire",
    era: "2026",
    position: [-40, 180, 20],
    target: [-124, 260, -112],
  },
  {
    key: "The Sphere",
    era: "2001",
    position: [-8, 14, 62],
    target: [-8, 7, -2],
  },
  {
    key: "Tobin Plaza",
    era: "2001",
    position: [-8, 60, 120],
    target: [-14, 120, -25],
  },
];

// Camera paths for transit modes (CatmullRom control points).
export const PATHS = {
  bridge: [
    [420, 52, 150],
    [700, 46, 150],
    [1000, 46, 150],
    [1280, 58, 150],
    [1200, 130, -120],
    [700, 160, -360],
    [280, 120, -240],
    [340, 74, 120],
  ],
  hudson: [
    [-660, 10, 720],
    [-640, 10, 380],
    [-620, 10, 40],
    [-620, 10, -300],
    [-660, 10, -560],
  ],
};

export const HUDSON_LOOK = [-46, 170, -46];
